import { finalProjectLink } from '../Activities/FinalProject'
import { finalProjectProposalLink } from '../Activities/FinalProjectProposal'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { classProjectPresentationLink } from '../Activities/FinalProject'
import { getFinalExamDateAndTime } from '../DataAndAPIs/ClassSections'
import { sprintEndDateWithoutTime } from '../CalendarAndSchedule/SprintDates'
import { scheduleLinkV2 } from '../DataAndAPIs/Links'
import { getClassSectionID } from '../DataAndAPIs/ClassSections'

export const al20000Sprint08 = () => {
	const sprint = 8
	return ( <div> 
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>
		<p>You made it. Very well done! Thank you for your dedication, support, and participation. All that’s left is 
		to put your final touches on your Class Project and present it to your classmates and instructor. Let’s finish 
		strong. It has been a sincere pleasure.</p>

		{list20000Sprint08()}
	</div> )
}

export const list20000Sprint08 = () => {
	const sprint = 8
	return ( <div>
		<p>Below is our activities list which, according to our {scheduleLinkV2(getClassSectionID(), sprint)}, needs to be 
		completed by {sprintEndDateWithoutTime(sprint-1)}:</p>
		<ol>
			<li>Review and update your {finalProjectProposalLink()} and {finalProjectLink()}</li>
			<li>Submit Lab 8 at least two hours before to you are scheduled to deliver your {classProjectPresentationLink()}</li>
			<li>Deliver your {classProjectPresentationLink()} in person on <u>{getFinalExamDateAndTime()}</u></li>
		</ol>
	</div>)
}

// Certified for SP25 on April 15, 2025